module.exports = __webpack_public_path__ + "static/media/alvin_dp_2.f868aab8.jpeg";